import request from '../util/http'

//查询地区所属担保机构
export function queryChanelByPcd(params) {
  return request({
    url: '/zcjf/biz/guarantee/channel/queryChanelByPcd',
    method: 'get',
    params,
  })
}

//获取默认选中出函机构
export function queryDefaultPartner(params) {
  return request({
    url: '/zcjf/biz/guarantee/channel/queryDefaultPartner',
    method: 'get',
    params,
  })
}


//查询地区所属保险机构
export function queryInsuranceChanelByPcd(params) {
  return request({
    url: '/zcjf/biz/guarantee/channel/queryInsuranceChanelByPcd',
    method: 'get',
    params,
  })
}


export function queryHbOrderInfo(str) {
  return request({
    url: '/zcjf/biz/guarantee/order/queryHbOrderInfo',
    method: 'post',
    data: {
      projectStr: str,
      querySource: 'zcjf',
    },
  })
}

export function calculateInsurance(params) {
  return request({
    url: '/zcjf/biz/guarantee/insurance/calculateInsurance',
    method: 'get',
    params,
  })
}

export function queryBankByProvince(params) {
  return request({
    url: '/zcjf/biz/guarantee/bank/queryBankByProvince',
    method: 'get',
    params,
  })
}

//银行保函提交

export const submitBank = (data) =>
  request({
    url: '/zcjf/biz/guarantee/bank/submitBank',
    method: 'post',
    data,
  })
export function signOrder(params) {
  return request({
    url: '/zcjf/biz/guarantee/order/signOrder',
    method: 'get',
    params,
  })
}
//担保保函提交
export const submitElectronic = (data) =>
  request({
    url: '/zcjf/biz/guarantee/electronic/submitElectronic',
    method: 'post',
    data,
  })
//保险保函提交
export const confirmInsurance = (data) =>
  request({
    url: '/zcjf/biz/guarantee/insurance/confirmInsurance',
    method: 'post',
    data,
  })

//校验是否需要签订承诺书
export const checkCommitment = (data) =>
  request({
    url: '/zcjf/biz/guarantee/electronic/checkCommitment',
    method: 'post',
    data,
  })

//预览签订承诺书
export function commitmentSign(params) {
  return request({
    url: '/zcjf/biz/guarantee/electronic/commitmentSign',
    method: 'get',
    params,
  })
}

// 判断是否线上支付
export function commitmentScendCallback(id) {
  return request({
    url: '/zcjf/biz/guarantee/electronic/commitmentScendCallback',
    method: 'get',
    params: {
      orderId: id,
    },
  })
}

export function submitCommitmentSign(params) {
  return request({
    url: '/zcjf/biz/guarantee/electronic/submitCommitmentSign',
    method: 'get',
    params,
  })
}
// 履约保函提交
export const submitPerformance = (data) =>
  request({
    url: '/zcjf/biz/guarantee/performance/submitPerformance',
    method: 'post',
    data,
  })
//获取配置
export const queryDockingPlatformOne = (param) =>
  request({
    url: '/zcjf/biz/guarantee/bfeDockingPlatform/queryDockingPlatformOne',
    method: 'get',
    params: {
      apiCode: param
    },
  })

//查询邢台保函项目信息
export const queryXtOrderInfo = (data) =>
  request({
    url: '/zcjf/biz/guarantee/oti/queryXtOrderInfo',
    method: 'post',
    data
  })

//查询字典
export const querySysValueData = (params) => {
  return request({
    url: '/zcjf/biz/sys/opt/querySysValueData',
    method: 'get',
    params
  })
}

//查询字典
export const querySysValueDataList = (params) => {
  return request({
    url: '/zcjf/biz/sys/opt/querySysValueDataList',
    method: 'get',
    params
  })
}

//查看是否为机构打款
export const queryPartnerRegionByPartnerId = (param) =>{
  return request({
    url: '/zcjf/biz/guarantee/channel/queryPartnerRegionByPartnerId',
    method: 'post',
    params: param
  })
  }

  
//查询保函支付方式
export const queryModePayment = (param) =>{
  return request({
    url: '/zcjf/biz/guarantee/channel/queryModePayment',
    method: 'post',
    params: param
  })
  }

  //查询对接平台相关信息
export const queryApiConfigInfo = (param) =>{
  return request({
    url: '/zcjf/biz/guarantee/channel/queryApiConfigInfo',
    method: 'post',
    params: param
  })
  }

//获取电子签章地址
export const getEelecSignUrl = (params) =>
  request({
    url: '/zcjf/biz/guarantee/hsyh/getEelecSignUrl',
    method: 'post',
    params,
  })